module.exports = __webpack_public_path__ + "media/vsl.24abd52a.mp4";